
// package imports
import { Col, Row } from "react-bootstrap"
// project imports
import "./gap-life-assured-details-card.css"
import GapProposerDetailsCard from "../gap-proposer-details-card/GapProposerDetailsCard"

const GapLifeAssuredDetailsCard = (props) => {
    const { LADetails } = props
    return (
        <>
            {LADetails.all_journey_list.map((item, index) => (
                <>
                    <Row className="gap-card mb-4 mx-0">
                        <Col className=" col-12 col-md-2 la-card-gap font-size-13 mb-3 mb-md-0">
                            <div>
                                <p className='font-size-12 mb-0 text-primary'>Life Assured Name</p>
                                <div className="border my-1 w-100 font-size-13 text-center">{item.la_name} </div>
                            </div>
                        </Col>

                        <Col className="col-12 col-md-10">
                            {item.journey_list.length > 1 ?
                                item.journey_list.map((data, index) => {
                                    return (
                                        <>
                                            <div className={`gap-child`}>
                                                <GapProposerDetailsCard
                                                    proposerData={data}
                                                />
                                                {item.journey_list.length !== index + 1 && (
                                                    <hr className='my-2 hr-gap' ></hr>
                                                )}
                                            </div>
                                        </>
                                    )
                                })
                                :
                                <div className={`gap-child`}>
                                    <GapProposerDetailsCard
                                        proposerData={item.journey_list[0]}
                                    />
                                </div>
                            }
                        </Col>
                       
                    </Row>
                 
                        
                 
                </>
            ))}
        </>
    )
}
export default GapLifeAssuredDetailsCard;
